// Operator auth endpoints — shapes mirror api/src/http/routes/operator.ts + the
// OperatorService. Login is PUBLIC (no token); /me is operator-authenticated.
import { z } from "zod";
import { apiFetch } from "../client";
import { operatorFetch } from "./client";

export interface OperatorIdentity {
  id: string;
  email: string;
  name: string | null;
  active: boolean;
  createdAt: string;
  lastLoginAt: string | null;
}

export const operatorSchema = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string().nullable(),
  active: z.boolean(),
  createdAt: z.string(),
  lastLoginAt: z.string().nullable(),
}) satisfies z.ZodType<OperatorIdentity>;

export interface OperatorLoginResponse {
  token: string;
  expiresInSeconds: number;
  operator: OperatorIdentity;
}

const loginResponseSchema = z.object({
  token: z.string().min(1),
  expiresInSeconds: z.number(),
  operator: operatorSchema,
}) satisfies z.ZodType<OperatorLoginResponse>;

/** PUBLIC operator login (no token yet). Validated at the boundary (ContractError on drift). */
export function operatorLogin(email: string, password: string): Promise<OperatorLoginResponse> {
  return apiFetch("/operator/login", { method: "POST", body: { email, password }, schema: loginResponseSchema });
}

/** The current operator's identity (confirms the session is still active). */
export function getOperatorMe(signal?: AbortSignal): Promise<{ operator: OperatorIdentity }> {
  return operatorFetch("/operator/me", { signal, schema: z.object({ operator: operatorSchema }) });
}
